// ===================================================================
// KAIXO - ChannelsV2 utils
// ===================================================================
// Helpers compartidos por los sub-componentes del módulo ChannelsV2.
// ===================================================================

/**
 * Extrae un id plano (string) de cualquier forma en la que pueda llegar:
 *  - string id ("abc123")   → "abc123"
 *  - ObjectId/objeto con _id ({_id: "abc123"}) → "abc123"
 *  - objeto con id ({id: "abc123"})            → "abc123"
 *  - ObjectId con toHexString (Mongoose driver) → "abc123"
 *  - null / undefined / objeto sin id           → ""
 *  - literal "[object Object]" (casteo erróneo aguas arriba) → ""
 *
 * El motivo de este helper es evitar de raíz el bug recurrente en el
 * que `String(obj)` produce el literal "[object Object]" y termina
 * incrustado en la URL de una petición, causando 400 en el backend.
 */
export function pickId(v) {
    if (v === null || v === undefined) return '';
    if (typeof v === 'string') {
        return v === '[object Object]' ? '' : v;
    }
    if (typeof v === 'object') {
        if (typeof v.toHexString === 'function') {
            try { return v.toHexString(); } catch { /* noop */ }
        }
        if (v._id) return pickId(v._id);
        if (v.id) return pickId(v.id);
        return '';
    }
    return String(v);
}
